var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClientNotesDock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8806 5.25169L10.4078 7.26826C10.0026 9.00984 9.20172 9.71419 7.69653 9.56946C7.45531 9.55017 7.1948 9.50675 6.91499 9.43921L6.10451 9.24623C4.09277 8.76862 3.47043 7.77481 3.94321 5.75824L4.416 3.73685C4.51248 3.32678 4.62826 2.96978 4.77299 2.6755C5.33744 1.50801 6.29748 1.19443 7.9088 1.57555L8.71446 1.7637C10.7358 2.23648 11.3534 3.23512 10.8806 5.25169Z",
    stroke: "#9E77ED",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.69404 9.56584C7.39493 9.76846 7.01863 9.93731 6.56032 10.0869L5.79808 10.3377C3.88283 10.9552 2.87454 10.439 2.25221 8.52379L1.63469 6.61818C1.01718 4.70292 1.52856 3.68981 3.44381 3.07229L4.20606 2.82143C4.40385 2.75871 4.592 2.70565 4.7705 2.67188C4.62577 2.96616 4.50999 3.32316 4.4135 3.73323L3.94072 5.75462C3.46793 7.77119 4.09027 8.765 6.10201 9.24261L6.9125 9.43558C7.19231 9.50313 7.45282 9.54654 7.69404 9.56584Z",
    stroke: "#9E77ED",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5293 4.32812L8.86909 4.92152",
    stroke: "#9E77ED",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.05664 6.19531L7.45569 6.55231",
    stroke: "#9E77ED",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientNotesDock);
export default __webpack_public_path__ + "static/media/clientNotesDock.5242d64712baf20e9e0cc6309fb14f7f.svg";
export { ForwardRef as ReactComponent };